import { QueryParams } from '@yme/common/constants';
export const CMP_LINK_QUERIES = {
    filterKey: 'filter',
    discountedKey: QueryParams.DISCOUNTED_MODE,
};
export var FilterType;
(function (FilterType) {
    FilterType["ACCESSORY_TYPE"] = "accessoryType";
    FilterType["COLLECTION"] = "collection";
    FilterType["IS_DISCOUNTED"] = "isDiscounted";
})(FilterType || (FilterType = {}));
export var DiscountedFilterValue;
(function (DiscountedFilterValue) {
    DiscountedFilterValue["YES"] = "yes";
    DiscountedFilterValue["NO"] = "no";
})(DiscountedFilterValue || (DiscountedFilterValue = {}));
